// Vorbelegung der Ziele je Stufe aus dem Werkskatalog (Vertrag W4.4). Reine Funktion, wird nirgends gemerkt:
// Jeder Transport beginnt neu mit dem Katalog. Noch nicht im Reducer verdrahtet (Phase B).
import { defaultTargetOf, normalizeSelection } from "./stageTargetSpace";

/**
 * `stageTargets`: Ziele je Stufe wie im Wizard, `plantTargets`: `{ [kennung]: { [stage]: targetId[] } }` (W4.3),
 * `kennungen`: gewählte Werke, `baseStage`: Stufe der Basisspalte (V.16).
 * Ergebnis `selection` (je Stufe die Vereinigung, danach normalisiert) und `source`
 * `{ [stage]: { [targetId]: kennung[] } }` nur für Ziele, die ein Katalogeintrag setzt (nicht das Standardziel).
 */
export function plantTargetPreset({ stageTargets, plantTargets, kennungen, baseStage = null }) {
  const plants = Array.isArray(kennungen) ? kennungen : [];
  const raw = {}, source = {};
  for (const [stage, rows] of Object.entries(stageTargets || {})) {
    if (stage === "dev" || !Array.isArray(rows) || !rows.length) continue;
    const standard = defaultTargetOf(rows).targetId;
    const known = rows.map(row => row.targetId);
    const chosen = new Set();
    for (const kennung of plants) {
      const entry = plantTargets?.[kennung]?.[stage];
      const ids = Array.isArray(entry) && entry.length ? entry.map(id => id === "default" ? standard : id) : [standard];
      for (const id of ids) {
        if (!known.includes(id)) continue;
        chosen.add(id);
        if (Array.isArray(entry) && entry.length && id !== standard) {
          const list = ((source[stage] ||= {})[id] ||= []);
          if (!list.includes(kennung)) list.push(kennung);
        }
      }
    }
    raw[stage] = known.filter(id => chosen.has(id));
  }
  return { selection: normalizeSelection(stageTargets, raw, baseStage), source };
}
